// Renderer-only registry of reactflow node/edge React components.
//
// These were previously embedded (as `container` / `nodeComponent` / `edgeTypes`)
// directly inside `nodeTypes` in bt-nodes-def.tsx. That coupling meant any module
// importing `nodeTypes` for its pure metadata (node handles / extraData / colors /
// titles) — e.g. ChatbotThunks & ChatbotSelectors, which are reachable from the
// content script via the Quick Agents sidebar — dragged the ENTIRE bot-builder
// flow-canvas UI (all node components + reactflow, ~391KB) into the content
// bundle app.js, even though the content script never renders the canvas.
//
// Splitting the component references out into this renderer-only module lets the
// metadata (bt-nodes-def.tsx) stay reactflow-free, so the content graph no longer
// reaches reactflow. Only the flow-canvas renderer (node-container.tsx,
// chatbot-flow.tsx — both website/dashboard-only) imports this file.
// See PERF_AUDIT_PROGRESS.md "R17-B".
import { NodeType } from '@common-models/bot-node';
import CustomEdge from '../custome-edge';
import AgentNode from './agent/agent-node';
import AgentNodeContainer from './agent/agent-node-container';
import ConditionNode from './condition/condition-node';
import ConditionNodeContainer from './condition/condition-node-container';
import GoogleSheetsNode from './google-sheets/google-sheets-node';
import GoogleSheetsContainer from './google-sheets/google-sheets-node-container';
import QuestionNode from './question/question-node';
import QuestionNodeContainer from './question/question-node-container';
import SendMessageNode from './send-message/send-message-node';
import SendMessageNodeContainer from './send-message/send-message-node-container';
import TriggerNode from './trigger/trigger-node';
import TriggerNodeContainer from './trigger/trigger-node-container';
import WebhookNode from './webhook/webhook-node';
import WebhookNodeContainer from './webhook/webhook-node-container';

export type NodeComponentDef = {
    container: any;
    nodeComponent: any;
};

export const nodeComponents: Record<NodeType, NodeComponentDef> = {
    'trigger': { container: TriggerNodeContainer, nodeComponent: TriggerNode },
    'sendMessage': { container: SendMessageNodeContainer, nodeComponent: SendMessageNode },
    'question': { container: QuestionNodeContainer, nodeComponent: QuestionNode },
    'webhook': { container: WebhookNodeContainer, nodeComponent: WebhookNode },
    'condition': { container: ConditionNodeContainer, nodeComponent: ConditionNode },
    'googleSheets': { container: GoogleSheetsContainer, nodeComponent: GoogleSheetsNode },
    'messageContact': { container: SendMessageNodeContainer, nodeComponent: SendMessageNode },
    'LLM': { container: SendMessageNodeContainer, nodeComponent: SendMessageNode },
    'agent': { container: AgentNodeContainer, nodeComponent: AgentNode },
};

export const edgeTypes = {
    'custom-edge': CustomEdge,
};
